import {
    SR_RISK_COLOR,
    SR_RISK_LEVEL_POINT,
    RISK_LEVEL_POINT,
    RISK_COLOR,
    SENIOR_RISK_LEVEL_POINT,
    SENIOR_RISK_COLOR,
    ISORATION_RISK_LEVEL_POINT,
    ISORATION_RISK_COLOR,
    BSN_RISK_LEVEL_POINT,
    CHRONOLOGY_CATEGORY_CODE,
    CHRONOLOGY_CATEGORY_COLOR,
    CHRONOLOGY_LEVEL_LABEL,
    CHRONOLOGY_LEVEL_COLOR,
    HAZERD_FLOOD_LEVEL_POINT,
    HAZERD_FLOOD_LEVEL_COLOR,
    HAZERD_INLAND_FLOOD_LEVEL_POINT,
    HAZERD_INLAND_FLOOD_LEVEL_COLOR,
    HAZERD_LANDSLIDE_LEVEL_POINT,
    HAZERD_LANDSLIDE_LEVEL_COLOR,
    RIVER_COLOR,
    MTR_BORDER_COLOR,
    TEL_LEVEL_POINT,
    TEL_LEVEL_STR,
    TEL_RISK_COLOR,
    TEL_RISK_LEVEL_POINT,
    RAIN_H1_LEVEL_POINT,
    RAIN_H24_LEVEL_POINT,
    RAIN_H48_LEVEL_POINT,
    RAIN_COLOR,
    ROAD_LEVEL_POINT,
    ROAD_COLOR,
    TYPHOON_LEVEL_POINT,
    TYPHOON_COLOR,
    WIND_LEVEL_POINT,
    WIND_COLOR,
    RAIN_H1_COLOR,
    SOIL_RISK_COLOR,
    SOIL_RAIN_COLOR,
    AREA_RISK_COLOR,
    SHELTER_ANALYSIS_LEVEL_POINT,
    SHELTER_ANALYSIS_COLOR,
    EVAC_AREA_LEVEL_POINT,
    EVAC_AREA_COLOR,
    EVAC_LEVEL_POINT,
    EVAC_COLOR,
    SHELTER_ANALYSIS_BAR_COLOR,
    SHELTER_ANALYSIS_BAR_LABEL,
    SHINDO_COLOR,
    OF_VAL_LEVEL,
    RIVER_RISK,
    BSN_RISK_COLOR,
    ROAD_RISK_LEVEL_POINT,
    ROAD_RISK_COLOR
} from '../const/color'

export const setRainColor = (POINT, risk) => {
    if (POINT.LEVEL_7 <= risk) {
        return RAIN_COLOR.LEVEL_8.color
    } else if (POINT.LEVEL_6 <= risk) {
        return RAIN_COLOR.LEVEL_7.color
    } else if (POINT.LEVEL_5 <= risk) {
        return RAIN_COLOR.LEVEL_6.color
    } else if (POINT.LEVEL_4 <= risk) {
        return RAIN_COLOR.LEVEL_5.color
    } else if (POINT.LEVEL_3 <= risk) {
        return RAIN_COLOR.LEVEL_4.color
    } else if (POINT.LEVEL_2 <= risk) {
        return RAIN_COLOR.LEVEL_3.color
    } else if (POINT.LEVEL_1 <= risk) {
        return RAIN_COLOR.LEVEL_2.color
    } else if (POINT.LEVEL_1 > risk) {
        return RAIN_COLOR.LEVEL_1.color
    } else {
        return RAIN_COLOR.OTHER.color
    }
}
export const setRainFontColor = (POINT, risk) => {
    if (POINT.LEVEL_7 <= risk) {
        return RAIN_COLOR.LEVEL_8.font_color
    } else if (POINT.LEVEL_6 <= risk) {
        return RAIN_COLOR.LEVEL_7.font_color
    } else if (POINT.LEVEL_5 <= risk) {
        return RAIN_COLOR.LEVEL_6.font_color
    } else if (POINT.LEVEL_4 <= risk) {
        return RAIN_COLOR.LEVEL_5.font_color
    } else if (POINT.LEVEL_3 <= risk) {
        return RAIN_COLOR.LEVEL_4.font_color
    } else if (POINT.LEVEL_2 <= risk) {
        return RAIN_COLOR.LEVEL_3.font_color
    } else if (POINT.LEVEL_1 <= risk) {
        return RAIN_COLOR.LEVEL_2.font_color
    } else if (POINT.LEVEL_1 > risk) {
        return RAIN_COLOR.LEVEL_1.font_color
    } else {
        return RAIN_COLOR.OTHER.font_color
    }
}

export const setRiskColor = (POINT, risk) => {
    if (POINT.LEVEL_4 <= risk) {
        return RISK_COLOR.LEVEL_5.color
    } else if (POINT.LEVEL_3 <= risk) {
        return RISK_COLOR.LEVEL_4.color
    } else if (POINT.LEVEL_2 <= risk) {
        return RISK_COLOR.LEVEL_3.color
    } else if (POINT.LEVEL_1 <= risk) {
        return RISK_COLOR.LEVEL_2.color
    } else if (POINT.LEVEL_1 > risk) {
        return RISK_COLOR.LEVEL_1.color
    } else {
        return RISK_COLOR.OTHER.color
    }
}

export const setBsnRiskColor = (POINT, risk) => {
    if (POINT.LEVEL_4 <= risk) {
        return BSN_RISK_COLOR.LEVEL_5.color
    } else if (POINT.LEVEL_3 <= risk) {
        return BSN_RISK_COLOR.LEVEL_4.color
    } else if (POINT.LEVEL_2 <= risk) {
        return BSN_RISK_COLOR.LEVEL_3.color
    } else if (POINT.LEVEL_1 <= risk) {
        return BSN_RISK_COLOR.LEVEL_2.color
    } else if (POINT.LEVEL_1 > risk) {
        return BSN_RISK_COLOR.LEVEL_1.color
    } else {
        return BSN_RISK_COLOR.OTHER.color
    }
}

export const setBsnRiskFontColor = (POINT, risk) => {
    if (POINT.LEVEL_4 <= risk) {
        return BSN_RISK_COLOR.LEVEL_5.font_color
    } else if (POINT.LEVEL_3 <= risk) {
        return BSN_RISK_COLOR.LEVEL_4.font_color
    } else if (POINT.LEVEL_2 <= risk) {
        return BSN_RISK_COLOR.LEVEL_3.font_color
    } else if (POINT.LEVEL_1 <= risk) {
        return BSN_RISK_COLOR.LEVEL_2.font_color
    } else if (POINT.LEVEL_1 > risk) {
        return BSN_RISK_COLOR.LEVEL_1.font_color
    } else {
        return BSN_RISK_COLOR.OTHER.font_color
    }
}

export const setRiskLabel = (POINT, risk_max) => {
    // 表示文言の設定
    if (POINT.LEVEL_4 <= risk_max) {
        return RISK_COLOR.LEVEL_5.label
    } else if (POINT.LEVEL_3 <= risk_max) {
        return RISK_COLOR.LEVEL_4.label
    } else if (POINT.LEVEL_2 <= risk_max) {
        return RISK_COLOR.LEVEL_3.label
    } else if (POINT.LEVEL_1 <= risk_max) {
        return RISK_COLOR.LEVEL_2.label
    } else if (POINT.LEVEL_1 > risk_max) {
        return RISK_COLOR.LEVEL_1.label
    } else {
        return RISK_COLOR.OTHER.label
    }
}
export const setRiskFontColor = (POINT, risk_max) => {
    // 表示文言の設定
    if (POINT.LEVEL_4 <= risk_max) {
        return RISK_COLOR.LEVEL_5.font_color
    } else if (POINT.LEVEL_3 <= risk_max) {
        return RISK_COLOR.LEVEL_4.font_color
    } else if (POINT.LEVEL_2 <= risk_max) {
        return RISK_COLOR.LEVEL_3.font_color
    } else if (POINT.LEVEL_1 <= risk_max) {
        return RISK_COLOR.LEVEL_2.font_color
    } else if (POINT.LEVEL_1 > risk_max) {
        return RISK_COLOR.LEVEL_1.font_color
    } else {
        return RISK_COLOR.OTHER.font_color
    }
}

export const setSrRiskColor = (risk) => {
    if (risk < SR_RISK_LEVEL_POINT.LEVEL_2) {
        return SOIL_RISK_COLOR.LEVEL_1
    } else if (risk < SR_RISK_LEVEL_POINT.LEVEL_3) {
        return SOIL_RISK_COLOR.LEVEL_2
    } else if (risk < SR_RISK_LEVEL_POINT.LEVEL_4) {
        return SOIL_RISK_COLOR.LEVEL_3
    } else if (risk < SR_RISK_LEVEL_POINT.LEVEL_5) {
        return SOIL_RISK_COLOR.LEVEL_4
    } else if (SR_RISK_LEVEL_POINT.LEVEL_5 <= risk) {
        return SOIL_RISK_COLOR.LEVEL_5
    } else {
        return SOIL_RISK_COLOR.LEVEL_1
    }
}

export const setSrColor = (POINT, risk_max) => {
    if (risk_max < POINT.LEVEL_2) {
        return SOIL_RAIN_COLOR.LEVEL_1.color
    } else if (risk_max < POINT.LEVEL_3) {
        return SOIL_RAIN_COLOR.LEVEL_2.color
    } else if (risk_max < POINT.LEVEL_4) {
        return SOIL_RAIN_COLOR.LEVEL_3.color
    } else if (risk_max < POINT.LEVEL_5) {
        return SOIL_RAIN_COLOR.LEVEL_4.color
    } else if (POINT.LEVEL_5 <= risk_max) {
        return SOIL_RAIN_COLOR.LEVEL_5.color
    } else {
        return SOIL_RAIN_COLOR.LEVEL_1.color
    }
}

export const setSrRiskLabel = (POINT, risk_max) => {
    // 表示文言の設定
    if (risk_max < POINT.LEVEL_2) {
        return SOIL_RAIN_COLOR.LEVEL_1.label
    } else if (risk_max < POINT.LEVEL_3) {
        return SOIL_RAIN_COLOR.LEVEL_2.label
    } else if (risk_max < POINT.LEVEL_4) {
        return SOIL_RAIN_COLOR.LEVEL_3.label
    } else if (risk_max < POINT.LEVEL_5) {
        return SOIL_RAIN_COLOR.LEVEL_4.label
    } else if (POINT.LEVEL_5 <= risk_max) {
        return SOIL_RAIN_COLOR.LEVEL_5.label
    } else {
        return SOIL_RAIN_COLOR.LEVEL_1.label
    }
}

export const setSrFontSize = (POINT, risk_max) => {
    if (risk_max < POINT.LEVEL_2) {
        return SOIL_RAIN_COLOR.LEVEL_1.font_size
    } else if (risk_max < POINT.LEVEL_3) {
        return SOIL_RAIN_COLOR.LEVEL_2.font_size
    } else if (risk_max < POINT.LEVEL_4) {
        return SOIL_RAIN_COLOR.LEVEL_3.font_size
    } else if (risk_max < POINT.LEVEL_5) {
        return SOIL_RAIN_COLOR.LEVEL_4.font_size
    } else if (POINT.LEVEL_5 <= risk_max) {
        return SOIL_RAIN_COLOR.LEVEL_5.font_size
    } else {
        return SOIL_RAIN_COLOR.OTHER.font_size
    }
}

export const setTelLevelColor = (risk) => {
    if (risk === TEL_LEVEL_POINT.BLUE) {
        return MTR_BORDER_COLOR.BLUE
    } else if (risk === TEL_LEVEL_POINT.GREEN) {
        return MTR_BORDER_COLOR.GREEN
    } else if (risk === TEL_LEVEL_POINT.YELLOW) {
        return MTR_BORDER_COLOR.YELLOW
    } else if (risk === TEL_LEVEL_POINT.RED) {
        return MTR_BORDER_COLOR.RED
    } else if (risk >= TEL_LEVEL_POINT.PURPLE) {
        return MTR_BORDER_COLOR.PURPLE
    } else {
        return MTR_BORDER_COLOR.OTHER
    }
}

export const setRiverRiskColor = (risk) => {
    if (5 < risk) {
        return RIVER_COLOR.LEVEL_5;
    } else if (4 < risk) {
        return RIVER_COLOR.LEVEL_4;
    } else if (3 < risk) {
        return RIVER_COLOR.LEVEL_3;
    } else if (2 < risk) {
        return RIVER_COLOR.LEVEL_2;
    } else if (1 < risk) {
        return RIVER_COLOR.LEVEL_1;
    } else {
        return RIVER_COLOR.OTHER;
    }
}
export const setSeniorRiskColor = (risk) => {
    if (SENIOR_RISK_LEVEL_POINT.LEVEL_5 < risk) {
        return SENIOR_RISK_COLOR.LEVEL_5
    } else if (SENIOR_RISK_LEVEL_POINT.LEVEL_4 < risk) {
        return SENIOR_RISK_COLOR.LEVEL_4
    } else if (SENIOR_RISK_LEVEL_POINT.LEVEL_3 < risk) {
        return SENIOR_RISK_COLOR.LEVEL_3
    } else if (SENIOR_RISK_LEVEL_POINT.LEVEL_2 < risk) {
        return SENIOR_RISK_COLOR.LEVEL_2
    } else {
        return SENIOR_RISK_COLOR.LEVEL_1
    }
}

export const setIsorationColor = (risk) => {
    if (risk < ISORATION_RISK_LEVEL_POINT.LEVEL_1) {
        return ISORATION_RISK_COLOR.LEVEL_1
    } else if (risk < ISORATION_RISK_LEVEL_POINT.LEVEL_2) {
        return ISORATION_RISK_COLOR.LEVEL_2
    } else if (risk < ISORATION_RISK_LEVEL_POINT.LEVEL_3) {
        return ISORATION_RISK_COLOR.LEVEL_3
    } else if (risk < ISORATION_RISK_LEVEL_POINT.LEVEL_4) {
        return ISORATION_RISK_COLOR.LEVEL_4
    } else if (risk < ISORATION_RISK_LEVEL_POINT.LEVEL_5) {
        return ISORATION_RISK_COLOR.LEVEL_5
    } else {
        return ISORATION_RISK_COLOR.LEVEL_6
    }
}

export const setChronologyColor = (cat) => {
    switch (cat) {
        case CHRONOLOGY_CATEGORY_CODE.COLLAPSE:
            return CHRONOLOGY_CATEGORY_COLOR.COLLAPSE
        case CHRONOLOGY_CATEGORY_CODE.WATERLV:
            return CHRONOLOGY_CATEGORY_COLOR.WATERLV
        case CHRONOLOGY_CATEGORY_CODE.CAVE_IN:
            return CHRONOLOGY_CATEGORY_COLOR.CAVE_IN
        case CHRONOLOGY_CATEGORY_CODE.ROAD:
            return CHRONOLOGY_CATEGORY_COLOR.ROAD
        case CHRONOLOGY_CATEGORY_CODE.FLOOD:
            return CHRONOLOGY_CATEGORY_COLOR.FLOOD
        case CHRONOLOGY_CATEGORY_CODE.WATER_CHANNEL:
            return CHRONOLOGY_CATEGORY_COLOR.WATER_CHANNEL
        case CHRONOLOGY_CATEGORY_CODE.POWER_OUTAGE:
            return CHRONOLOGY_CATEGORY_COLOR.POWER_OUTAGE
        case CHRONOLOGY_CATEGORY_CODE.WATER_OUTAGE:
            return CHRONOLOGY_CATEGORY_COLOR.WATER_OUTAGE
        case CHRONOLOGY_CATEGORY_CODE.GAS:
            return CHRONOLOGY_CATEGORY_COLOR.GAS
        case CHRONOLOGY_CATEGORY_CODE.COMMUNICATION:
            return CHRONOLOGY_CATEGORY_COLOR.COMMUNICATION
        case CHRONOLOGY_CATEGORY_CODE.WIND_LIGNTNING:
            return CHRONOLOGY_CATEGORY_COLOR.WIND_LIGNTNING
        case CHRONOLOGY_CATEGORY_CODE.FIRE:
            return CHRONOLOGY_CATEGORY_COLOR.FIRE
        case CHRONOLOGY_CATEGORY_CODE.TSUNAMI:
            return CHRONOLOGY_CATEGORY_COLOR.TSUNAMI
        default:
            return CHRONOLOGY_CATEGORY_COLOR.OTHER
    }
}
// export const setChronologyLevelColor = (level) => {
//     switch (level) {
//         case CHRONOLOGY_LEVEL.LOW:
//             return CHRONOLOGY_LEVEL_COLOR.LOW
//         case CHRONOLOGY_LEVEL.MIDDLE:
//             return CHRONOLOGY_LEVEL_COLOR.MIDDLE
//         case CHRONOLOGY_LEVEL.HIGHT:
//             return CHRONOLOGY_LEVEL_COLOR.HIGHT
//         case CHRONOLOGY_LEVEL.OTHER:
//             return CHRONOLOGY_LEVEL_COLOR.OTHER
//         default:
//             return CHRONOLOGY_LEVEL_COLOR.OTHER
//     }
// }

export const setChronologyLevelColor = (level) => {
    switch (level) {
        case CHRONOLOGY_LEVEL_LABEL.LEVER_1:
            return CHRONOLOGY_LEVEL_COLOR.LEVER_1
        case CHRONOLOGY_LEVEL_LABEL.LEVER_2:
            return CHRONOLOGY_LEVEL_COLOR.LEVER_2
        case CHRONOLOGY_LEVEL_LABEL.LEVER_3:
            return CHRONOLOGY_LEVEL_COLOR.LEVER_3
        case CHRONOLOGY_LEVEL_LABEL.LEVER_4:
            return CHRONOLOGY_LEVEL_COLOR.LEVER_4
        case CHRONOLOGY_LEVEL_LABEL.LEVER_5:
            return CHRONOLOGY_LEVEL_COLOR.LEVER_5
        case CHRONOLOGY_LEVEL_LABEL.LEVER_6:
            return CHRONOLOGY_LEVEL_COLOR.LEVER_6
        case CHRONOLOGY_LEVEL_LABEL.LEVER_7:
            return CHRONOLOGY_LEVEL_COLOR.LEVER_7
        case CHRONOLOGY_LEVEL_LABEL.LEVER_8:
            return CHRONOLOGY_LEVEL_COLOR.LEVER_8
        case CHRONOLOGY_LEVEL_LABEL.LEVER_9:
            return CHRONOLOGY_LEVEL_COLOR.LEVER_9
        default:
            return CHRONOLOGY_LEVEL_COLOR.DEFAULT
    }
}

export const hazerdFloodColor = (level) => {
    switch (level) {
        case HAZERD_FLOOD_LEVEL_POINT.LEVEL_1:
            return HAZERD_FLOOD_LEVEL_COLOR.LEVEL_1
        case HAZERD_FLOOD_LEVEL_POINT.LEVEL_2:
            return HAZERD_FLOOD_LEVEL_COLOR.LEVEL_2
        case HAZERD_FLOOD_LEVEL_POINT.LEVEL_3:
            return HAZERD_FLOOD_LEVEL_COLOR.LEVEL_3
        case HAZERD_FLOOD_LEVEL_POINT.LEVEL_4:
            return HAZERD_FLOOD_LEVEL_COLOR.LEVEL_4
        case HAZERD_FLOOD_LEVEL_POINT.LEVEL_5:
            return HAZERD_FLOOD_LEVEL_COLOR.LEVEL_5
        case HAZERD_FLOOD_LEVEL_POINT.LEVEL_6:
            return HAZERD_FLOOD_LEVEL_COLOR.LEVEL_6
        default:
            return HAZERD_FLOOD_LEVEL_COLOR.OTHER
    }
}
export const hazerdInlandFloodColor = (level) => {
    switch (level) {
        case HAZERD_INLAND_FLOOD_LEVEL_POINT.LEVEL_1:
            return HAZERD_INLAND_FLOOD_LEVEL_COLOR.LEVEL_1
        case HAZERD_INLAND_FLOOD_LEVEL_POINT.LEVEL_2:
            return HAZERD_INLAND_FLOOD_LEVEL_COLOR.LEVEL_2
        case HAZERD_INLAND_FLOOD_LEVEL_POINT.LEVEL_3:
            return HAZERD_INLAND_FLOOD_LEVEL_COLOR.LEVEL_3
        case HAZERD_INLAND_FLOOD_LEVEL_POINT.LEVEL_4:
            return HAZERD_INLAND_FLOOD_LEVEL_COLOR.LEVEL_4
        default:
            return HAZERD_INLAND_FLOOD_LEVEL_COLOR.OTHER
    }
}
export const hazerdLandslideColor = (level) => {
    switch (level) {
        case HAZERD_LANDSLIDE_LEVEL_POINT.LEVEL_1:
            return HAZERD_LANDSLIDE_LEVEL_COLOR.LEVEL_1
        case HAZERD_LANDSLIDE_LEVEL_POINT.LEVEL_2:
            return HAZERD_LANDSLIDE_LEVEL_COLOR.LEVEL_2
        default:
            return HAZERD_LANDSLIDE_LEVEL_COLOR.OTHER
    }
}

export const setSizeThree = () => {
    return 3
};

export const setSrCitySize = (risk) => {
    if (risk < SR_RISK_LEVEL_POINT.LEVEL_2) {
        return 10
    } else if (risk < SR_RISK_LEVEL_POINT.LEVEL_3) {
        return 15
    } else if (risk < SR_RISK_LEVEL_POINT.LEVEL_4) {
        return 20
    } else if (risk < SR_RISK_LEVEL_POINT.LEVEL_5) {
        return 25
    } else if (SR_RISK_LEVEL_POINT.LEVEL_5 <= risk) {
        return 30
    } else {
        return 10
    }
};

export const setCitySize = (risk) => {
    if (risk < RISK_LEVEL_POINT.LEVEL_1) {
        return 10
    } else if (risk < RISK_LEVEL_POINT.LEVEL_2) {
        return 15
    } else if (risk < RISK_LEVEL_POINT.LEVEL_3) {
        return 20
    } else if (risk < RISK_LEVEL_POINT.LEVEL_4) {
        return 25
    } else if (RISK_LEVEL_POINT.LEVEL_4 <= risk) {
        return 30
    } else {
        return 10
    }
};

export const setSizeRandom = (risk) => {
    return risk / 100
};

export const setTelLevelStr = (risk) => {
    if (risk === TEL_LEVEL_POINT.BLUE) {
        return TEL_LEVEL_STR.BLUE
    } else if (risk === TEL_LEVEL_POINT.GREEN) {
        return TEL_LEVEL_STR.GREEN
    } else if (risk === TEL_LEVEL_POINT.YELLOW) {
        return TEL_LEVEL_STR.YELLOW
    } else if (risk === TEL_LEVEL_POINT.RED) {
        return TEL_LEVEL_STR.RED
    } else if (risk >= TEL_LEVEL_POINT.PURPLE) {
        return TEL_LEVEL_STR.PURPLE
    } else {
        return TEL_LEVEL_STR.OTHER
    }
};

export const setTelRiskColor = (risk) => {
    if (risk < TEL_RISK_LEVEL_POINT.LEVEL_3) {
        return TEL_RISK_COLOR.LEVEL_2
    } else if (risk < TEL_RISK_LEVEL_POINT.LEVEL_4) {
        return TEL_RISK_COLOR.LEVEL_3
    } else if (risk < TEL_RISK_LEVEL_POINT.LEVEL_5) {
        return TEL_RISK_COLOR.LEVEL_4
    } else if (risk < TEL_RISK_LEVEL_POINT.LEVEL_6) {
        return TEL_RISK_COLOR.LEVEL_5
    } else if (TEL_RISK_LEVEL_POINT.LEVEL_6 <= risk) {
        return TEL_RISK_COLOR.LEVEL_6
    } else {
        return TEL_RISK_COLOR.LEVEL_1
    }
}

export const setRoadColor = (risk) => {
    if (risk === 4) {
        return ROAD_COLOR.LEVEL_4
    } else if (risk === 3) {
        return ROAD_COLOR.LEVEL_3
    } else if (risk === 2) {
        return ROAD_COLOR.LEVEL_2
    } else if (risk === 1) {
        return ROAD_COLOR.LEVEL_1
    } else {
        return ROAD_COLOR.LEVEL_0
    }
}

export const setTyphoonColor = (risk) => {
    if (risk < TYPHOON_LEVEL_POINT.LEVEL_1) {
        return TYPHOON_COLOR.LEVEL_1
    } else if (risk < TYPHOON_LEVEL_POINT.LEVEL_2) {
        return TYPHOON_COLOR.LEVEL_2
    } else if (risk < TYPHOON_LEVEL_POINT.LEVEL_3) {
        return TYPHOON_COLOR.LEVEL_3
    } else if (risk < TYPHOON_LEVEL_POINT.LEVEL_4) {
        return TYPHOON_COLOR.LEVEL_4
    } else {
        return TYPHOON_COLOR.LEVEL_4
    }
}

// 風の色分けを設定
export const setWindColor = (risk) => {
    if (risk < 0) {
        return WIND_COLOR.OTHER
    } else if (risk < WIND_LEVEL_POINT.LEVEL_1) {
        return WIND_COLOR.LEVEL_1
    } else if (risk < WIND_LEVEL_POINT.LEVEL_2) {
        return WIND_COLOR.LEVEL_2
    } else if (risk < WIND_LEVEL_POINT.LEVEL_3) {
        return WIND_COLOR.LEVEL_3
    } else if (risk < WIND_LEVEL_POINT.LEVEL_4) {
        return WIND_COLOR.LEVEL_4
    } else if (risk < WIND_LEVEL_POINT.LEVEL_5) {
        return WIND_COLOR.LEVEL_5
    } else if (risk >= WIND_LEVEL_POINT.LEVEL_5) {
        return WIND_COLOR.LEVEL_6
    } else {
        return WIND_COLOR.OTHER
    }
}

export const setAreaRiskFontSize = (POINT, risk_max) => {
    // 表示文言の設定
    if (POINT.LEVEL_4 <= risk_max) {
        return AREA_RISK_COLOR.LEVEL_5.font_size
    } else if (POINT.LEVEL_3 <= risk_max) {
        return AREA_RISK_COLOR.LEVEL_4.font_size
    } else if (POINT.LEVEL_2 <= risk_max) {
        return AREA_RISK_COLOR.LEVEL_3.font_size
    } else if (POINT.LEVEL_1 <= risk_max) {
        return AREA_RISK_COLOR.LEVEL_2.labfont_sizeel
    } else if (POINT.LEVEL_1 > risk_max) {
        return AREA_RISK_COLOR.LEVEL_1.font_size
    } else {
        return AREA_RISK_COLOR.OTHER.font_size
    }
}

export const setAreaRiskLabel = (POINT, risk_max) => {
    // 表示文言の設定
    if (POINT.LEVEL_4 <= risk_max) {
        return AREA_RISK_COLOR.LEVEL_5.label
    } else if (POINT.LEVEL_3 <= risk_max) {
        return AREA_RISK_COLOR.LEVEL_4.label
    } else if (POINT.LEVEL_2 <= risk_max) {
        return AREA_RISK_COLOR.LEVEL_3.label
    } else if (POINT.LEVEL_1 <= risk_max) {
        return AREA_RISK_COLOR.LEVEL_2.label
    } else if (POINT.LEVEL_1 > risk_max) {
        return AREA_RISK_COLOR.LEVEL_1.label
    } else {
        return AREA_RISK_COLOR.OTHER.label
    }
}

export const setAreaRiskColor = (POINT, risk) => {
    if (POINT.LEVEL_4 <= risk) {
        return AREA_RISK_COLOR.LEVEL_5.color
    } else if (POINT.LEVEL_3 <= risk) {
        return AREA_RISK_COLOR.LEVEL_4.color
    } else if (POINT.LEVEL_2 <= risk) {
        return AREA_RISK_COLOR.LEVEL_3.color
    } else if (POINT.LEVEL_1 <= risk) {
        return AREA_RISK_COLOR.LEVEL_2.color
    } else if (POINT.LEVEL_1 > risk) {
        return AREA_RISK_COLOR.LEVEL_1.color
    } else {
        return AREA_RISK_COLOR.OTHER.color
    }
}

// 避難所の色分けを設定
export const setShelterLevelColor = (status_category_name) => {
    if (status_category_name === SHELTER_ANALYSIS_LEVEL_POINT.LEVEL_1) {
        return SHELTER_ANALYSIS_COLOR.LEVEL_1
    } else if (status_category_name === SHELTER_ANALYSIS_LEVEL_POINT.LEVEL_2) {
        return SHELTER_ANALYSIS_COLOR.LEVEL_2
    } else if (status_category_name === SHELTER_ANALYSIS_LEVEL_POINT.LEVEL_3) {
        return SHELTER_ANALYSIS_COLOR.LEVEL_3
    } else if (status_category_name === SHELTER_ANALYSIS_LEVEL_POINT.LEVEL_4) {
        return SHELTER_ANALYSIS_COLOR.LEVEL_4
    } else if (status_category_name === SHELTER_ANALYSIS_LEVEL_POINT.LEVEL_5) {
        return SHELTER_ANALYSIS_COLOR.LEVEL_5
    } else if (status_category_name === SHELTER_ANALYSIS_LEVEL_POINT.LEVEL_6) {
        return SHELTER_ANALYSIS_COLOR.LEVEL_6
    }else {
        return SHELTER_ANALYSIS_COLOR.LEVEL_1
    }
}

// 避難指示発令地域の色分けを設定
export const setEvacAreaLevelColor = (status_category) => {
    if (status_category === EVAC_AREA_LEVEL_POINT.LEVEL_1) {
        return EVAC_AREA_COLOR.LEVEL_1
    } else if (status_category === EVAC_AREA_LEVEL_POINT.LEVEL_2) {
        return EVAC_AREA_COLOR.LEVEL_2
    } else if (status_category === EVAC_AREA_LEVEL_POINT.LEVEL_3) {
        return EVAC_AREA_COLOR.LEVEL_3
    } else if (status_category === EVAC_AREA_LEVEL_POINT.LEVEL_4) {
        return EVAC_AREA_COLOR.LEVEL_4
    } else if (status_category === EVAC_AREA_LEVEL_POINT.LEVEL_5) {
        return EVAC_AREA_COLOR.LEVEL_5
    } else {
        return EVAC_AREA_COLOR.LEVEL_0
    }
}

export const setEvacColor = (evac) => {
    if (evac < EVAC_LEVEL_POINT.LEVEL_2) {
        return EVAC_COLOR.LEVEL_1
    } else if (evac < EVAC_LEVEL_POINT.LEVEL_3) {
        return EVAC_COLOR.LEVEL_2
    } else if (evac < EVAC_LEVEL_POINT.LEVEL_4) {
        return EVAC_COLOR.LEVEL_3
    } else if (evac < EVAC_LEVEL_POINT.LEVEL_5) {
        return EVAC_COLOR.LEVEL_4
    } else if (EVAC_LEVEL_POINT.LEVEL_5 <= evac) {
        return EVAC_COLOR.LEVEL_5
    } else {
        return EVAC_COLOR.LEVEL_1
    }
}

export const setShelterAnalysisColor = (label) => {
    switch (label) {
        case SHELTER_ANALYSIS_BAR_LABEL.COVID_19:
            return SHELTER_ANALYSIS_BAR_COLOR.COVID_19
        case SHELTER_ANALYSIS_BAR_LABEL.FLU:
            return SHELTER_ANALYSIS_BAR_COLOR.FLU
        case SHELTER_ANALYSIS_BAR_LABEL.MYCO:
            return SHELTER_ANALYSIS_BAR_COLOR.MYCO
        case SHELTER_ANALYSIS_BAR_LABEL.MYCO_CHILD:
            return SHELTER_ANALYSIS_BAR_COLOR.MYCO_CHILD
        case SHELTER_ANALYSIS_BAR_LABEL.RS:
            return SHELTER_ANALYSIS_BAR_COLOR.RS
        case SHELTER_ANALYSIS_BAR_LABEL.CHLAMYDIA:
            return SHELTER_ANALYSIS_BAR_COLOR.CHLAMYDIA
        case SHELTER_ANALYSIS_BAR_LABEL.HERPANGINA:
            return SHELTER_ANALYSIS_BAR_COLOR.HERPANGINA
        case SHELTER_ANALYSIS_BAR_LABEL.MUMPS:
            return SHELTER_ANALYSIS_BAR_COLOR.MUMPS
        case SHELTER_ANALYSIS_BAR_LABEL.ROTA:
            return SHELTER_ANALYSIS_BAR_COLOR.ROTA
        case SHELTER_ANALYSIS_BAR_LABEL.PHARYNGOCONJUNCTIVAL:
            return SHELTER_ANALYSIS_BAR_COLOR.PHARYNGOCONJUNCTIVAL
        case SHELTER_ANALYSIS_BAR_LABEL.APPLE:
            return SHELTER_ANALYSIS_BAR_COLOR.APPLE
        case SHELTER_ANALYSIS_BAR_LABEL.ACUTE_HEMORRHAGIC_CONJUNCTIVITIS:
            return SHELTER_ANALYSIS_BAR_COLOR.ACUTE_HEMORRHAGIC_CONJUNCTIVITIS
        case SHELTER_ANALYSIS_BAR_LABEL.HAND_FOOT_MOUTH:
            return SHELTER_ANALYSIS_BAR_COLOR.HAND_FOOT_MOUTH
        case SHELTER_ANALYSIS_BAR_LABEL.ACUTE_INFECTIOUS_GASTROENTERITIS:
            return SHELTER_ANALYSIS_BAR_COLOR.ACUTE_INFECTIOUS_GASTROENTERITIS
        case SHELTER_ANALYSIS_BAR_LABEL.CHICKEN_POX:
            return SHELTER_ANALYSIS_BAR_COLOR.CHICKEN_POX
        case SHELTER_ANALYSIS_BAR_LABEL.EPIDEMIC_CONJUNCTIVITIS:
            return SHELTER_ANALYSIS_BAR_COLOR.EPIDEMIC_CONJUNCTIVITIS
        case SHELTER_ANALYSIS_BAR_LABEL.ASEPTIC_SPINAL_CORD_MENINGITIS:
            return SHELTER_ANALYSIS_BAR_COLOR.ASEPTIC_SPINAL_CORD_MENINGITIS
        case SHELTER_ANALYSIS_BAR_LABEL.EXANTHEM_SUBITUM:
            return SHELTER_ANALYSIS_BAR_COLOR.EXANTHEM_SUBITUM
        case SHELTER_ANALYSIS_BAR_LABEL.BACTERIAL_MENINGITIS:
            return SHELTER_ANALYSIS_BAR_COLOR.BACTERIAL_MENINGITIS
        case SHELTER_ANALYSIS_BAR_LABEL.GROUP_A_HEMOLYTIC:
            return SHELTER_ANALYSIS_BAR_COLOR.GROUP_A_HEMOLYTIC
        default:
            return SHELTER_ANALYSIS_BAR_COLOR.DEFAULT
    }
}

export const setShindoLevelColor = (shindo) => {
    const value = Number(shindo);
    if (!Number.isFinite(value)) return SHINDO_COLOR.LEVEL_1;
    if (value < 1.5) return SHINDO_COLOR.LEVEL_1;
    if (value < 2.5) return SHINDO_COLOR.LEVEL_2;
    if (value < 3.5) return SHINDO_COLOR.LEVEL_3;
    if (value < 4.5) return SHINDO_COLOR.LEVEL_4;
    if (value < 5.0) return SHINDO_COLOR.LEVEL_5_WEAK;
    if (value < 5.5) return SHINDO_COLOR.LEVEL_5_STRONG;
    if (value < 6.0) return SHINDO_COLOR.LEVEL_6_WEAK;
    if (value < 6.5) return SHINDO_COLOR.LEVEL_6_STRONG;

    return SHINDO_COLOR.LEVEL_7;
}

export const setRiskRiverColor = (river) => {
  const item = RIVER_RISK.find(r => river < r.max);
  return item ? item.color : "#000";
};

export const setOfValRiverColor = (of_val) => {
  const item = OF_VAL_LEVEL.find(level => of_val >= level.min);
  return item ? item.color : "#000";
};

export const setRoadRiskColor = (risk) => {
    if (risk < ROAD_RISK_LEVEL_POINT.LEVEL_1) {
        return ROAD_RISK_COLOR.LEVEL_0
    } else if (risk < ROAD_RISK_LEVEL_POINT.LEVEL_2) {
        return ROAD_RISK_COLOR.LEVEL_1
    } else if (risk < ROAD_RISK_LEVEL_POINT.LEVEL_3) {
        return ROAD_RISK_COLOR.LEVEL_2
    } else if (risk < ROAD_RISK_LEVEL_POINT.LEVEL_4) {
        return ROAD_RISK_COLOR.LEVEL_3
    } else if (TEL_RISK_LEVEL_POINT.LEVEL_4 <= risk) {
        return ROAD_RISK_COLOR.LEVEL_4
    } else {
        return ROAD_RISK_COLOR.LEVEL_0
    }
}
